import { z } from 'zod';

import {
  featureIdSchema,
  featureLimitSchema,
  planIdSchema,
  type FeatureId,
  type FeatureLimit,
  type PlanId,
} from '../billing/plans';

/** Wire shape for GET /v1/me/subscription (PRE-247). */
export const subscriptionStatusSchema = z.object({
  planId: planIdSchema,
  isActive: z.boolean(),
  productIdentifier: z.string().nullable(),
  store: z.string().nullable(),
  expiresAt: z.string().nullable(),
  willRenew: z.boolean(),
  /** Resolved feature ceilings for the current plan (unlimited | number). */
  features: z.record(featureIdSchema, featureLimitSchema),
  /** RC entitlement identifiers currently mirrored for this user. */
  entitlementIds: z.array(z.string()),
});
export type SubscriptionStatus = z.infer<typeof subscriptionStatusSchema>;

/** Compact entitlement fields for admin Users list/detail. */
export const adminEntitlementSummarySchema = z.object({
  planId: planIdSchema,
  isActive: z.boolean(),
  expiresAt: z.string().nullable(),
  productIdentifier: z.string().nullable(),
  store: z.string().nullable(),
  willRenew: z.boolean(),
});
export type AdminEntitlementSummary = z.infer<typeof adminEntitlementSummarySchema>;

export type { FeatureId, FeatureLimit, PlanId };
